const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}


/*кастом*/

function animateOnScroll() {
  const elements = document.querySelectorAll('.custom-block');
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animated');
        // Останавливаем наблюдение после анимации
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.3, // Анимация запустится когда 30% элемента видно
    rootMargin: '0px 0px -50px 0px' // Небольшой отступ снизу
  });

  elements.forEach(element => {
    observer.observe(element);
  });
}

// Запускаем при загрузке страницы
document.addEventListener('DOMContentLoaded', animateOnScroll);

// И при изменении контента (для Shopify)
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', animateOnScroll);
}

// Функция для анимации при скролле
function animateOnScroll() {
  // Находим все элементы по существующим классам
  const elements = document.querySelectorAll(
    '.custom-block, .manifesto-container, .featured-container, .custom-footer'
  );
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animated');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.3,
    rootMargin: '0px 0px -50px 0px'
  });

  elements.forEach(element => {
    // Добавляем наблюдатель только если элемент еще не анимирован
    if (!element.classList.contains('animated')) {
      observer.observe(element);
    }
  });
}

// Запускаем при загрузке страницы
document.addEventListener('DOMContentLoaded', animateOnScroll);

// Для Shopify редактора
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', function() {
    // Даем время на рендер нового контента
    setTimeout(animateOnScroll, 100);
  });
}

// Перезапуск анимации при изменении размера окна
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    // Сбрасываем анимацию для элементов вне viewport
    const animatedElements = document.querySelectorAll(
      '.custom-block.animated, .manifesto-container.animated, .featured-container.animated, .custom-footer.animated'
    );
    
    animatedElements.forEach(element => {
      const rect = element.getBoundingClientRect();
      // Если элемент вне viewport, сбрасываем анимацию
      if (rect.top > window.innerHeight || rect.bottom < 0) {
        element.classList.remove('animated');
      }
    });
    
    // Перезапускаем наблюдение
    setTimeout(animateOnScroll, 100);
  }, 250);
});

document.addEventListener('DOMContentLoaded', function() {
  const observerOptions = {
    threshold: 0.2,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animated');
      }
    });
  }, observerOptions);

  // Наблюдаем за нужными контейнерами
  document.querySelectorAll('.featured-container, .services-container, .stats-container')
    .forEach(container => observer.observe(container));
});

// Добавьте этот код в конец вашего файла
document.addEventListener('DOMContentLoaded', function() {
    // Находим все карточки товаров
    const productCards = document.querySelectorAll('[data-same-height-subgrid-container="true"]');
    
    productCards.forEach(card => {
        // Находим контейнер изображения внутри карточки
        const imageContainer = card.querySelector('.gp-featured-image-wrapper, .gp-group, [type="gp-feature-image-only"]');
        
        if (imageContainer) {
            // Добавляем CSS для zoom эффекта
            imageContainer.style.overflow = 'hidden';
            
            const img = imageContainer.querySelector('img');
            if (img) {
                img.style.transition = 'transform 0.5s ease';
                
                // Добавляем обработчики событий
                imageContainer.addEventListener('mouseenter', () => {
                    img.style.transform = 'scale(1.1)';
                });
                
                imageContainer.addEventListener('mouseleave', () => {
                    img.style.transform = 'scale(1)';
                });
            }
        }
    });
});


document.addEventListener('DOMContentLoaded', function() {
  // Находим все проблемные изображения
  const images = document.querySelectorAll('.multicolumn-card__image');
  
  images.forEach(img => {
    // Принудительно задаем стили
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = 'cover';
    img.style.display = 'block';
    
    // Находим родительский контейнер
    const wrapper = img.closest('.multicolumn-card__image-wrapper');
    const mediaContainer = img.closest('.media');
    
    if (wrapper) {
      wrapper.style.width = '100%';
      wrapper.style.overflow = 'hidden';
    }
    
    if (mediaContainer) {
      mediaContainer.style.width = '100%';
      mediaContainer.style.height = '400px'; // или любая нужная высота
      mediaContainer.style.paddingBottom = '0';
    }
  });
});


